import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { TimelineLabelType, OwnerType, DashboardTimelineType } from '../../../constants/ComponentTypes';
import Loader from "../../Parts/Loader";
import { hasKLFollowCallBeenEnabled } from '../../../utils/userUtils';
import PanelHeader from '../parts/PanelHeader';
import { connect } from 'react-redux';
import { getDayBeforeCountByStatus } from '../../../redux/actions/CurrentPersonStatus';

const styles = () => ({
  root: {
    width: '100%',
    padding: '22px 25px 32px 25px',
    background: '#FFFFFF',
    boxShadow: '0px 1px 2px #0000001F',
    borderRadius: '4px',
    boxSizing: 'border-box',
    marginBottom: '24px',
  },

  loaderContainer: {
    height: "100px",
    position: "relative",
    width: "100%",
  },

  comparisonContainer: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    textAlign: 'center',
  },

  box: {
    flexBasis: 0,
    flexGrow: 1,
    fontSize: 12,
  },

  count: {
    fontSize: 23,
    marginTop: 10,
  },

  circle: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: 5,
    verticalAlign: 'text-top',
  },
});

class StatusDailyComparisonPanel extends React.Component {
  componentDidMount() {
    let query = this.filterValueToQuery();
    !this.props.isDemo && this.props.getDayBeforeCountByStatus({
      ...query
    }, true);
  }

  componentDidUpdate(prevProps) {
    // 上位コンポーネントのステートによって、初期クエリ化のクエリを実行するが、このコンポーネントは日付検索などの検索条件がないため、初期化処理はせずに検索。
    if (prevProps.ownerType && prevProps.ownerType !== this.props.ownerType) {
      let query = this.filterValueToQuery();
      !this.props.isDemo && this.props.getDayBeforeCountByStatus({
        ...query
      }, true);
    }
  }

  filterValueToQuery = (ownerType = this.props.ownerType) => {
    // @see クエリを組み立てるとき、前日比は日付範囲を指定すると、currentPeronStatusのstated_atを絞ってしまうため、指定しない。
    let data = {};

    data["is_own"] = ownerType === OwnerType.OWN.value ? 'true' : 'false';

    return data;
  }

  getDayBeforeCount = (type) => {
    const { pageInfos } = this.props;

    const pageInfo = pageInfos[type];
    let count = 0;

    if (pageInfo && pageInfo.hasOwnProperty('daily_summaries')) {
      if (type === TimelineLabelType.APPOINTMENT.value && pageInfo.daily_summaries.hasOwnProperty("appointment_count")) {
        count = pageInfo.daily_summaries["appointment_count"];
      } else if (type === TimelineLabelType.CLOSE.value && pageInfo.daily_summaries.hasOwnProperty("close_count")) {
        count = pageInfo.daily_summaries["close_count"];
      } else if (type === TimelineLabelType.APPROACH_NG.value && pageInfo.daily_summaries.hasOwnProperty("approach_ng_count")) {
        count = pageInfo.daily_summaries["approach_ng_count"];
      } else if (type === TimelineLabelType.QR_CODE_REACTION.value && pageInfo.daily_summaries.hasOwnProperty("qr_code_reaction_count")) {
        count = pageInfo.daily_summaries["qr_code_reaction_count"];
      } else if (type === TimelineLabelType.NON_CONNECT.value && pageInfo.daily_summaries.hasOwnProperty("non_connect_count")) {
        count = pageInfo.daily_summaries["non_connect_count"];
      } else if (type === TimelineLabelType.DECLINED.value && pageInfo.daily_summaries.hasOwnProperty("declined_count")) {
        count = pageInfo.daily_summaries["declined_count"];
      } else if (type === TimelineLabelType.CONNECT.value && pageInfo.daily_summaries.hasOwnProperty("connect_count")) {
        count = pageInfo.daily_summaries["connect_count"];
      } else if (type === TimelineLabelType.SENT_DOCUMENT.value && pageInfo.daily_summaries.hasOwnProperty("sent_document_count")) {
        count = pageInfo.daily_summaries["sent_document_count"];
      } else if (type === "lead_note" && pageInfo.daily_summaries.hasOwnProperty("lead_note_count")) {
        count = pageInfo.daily_summaries["lead_note_count"];
      } else if (type === TimelineLabelType.APPROACH.value && pageInfo.daily_summaries.hasOwnProperty("approach_count")) {
        count = pageInfo.daily_summaries["approach_count"];
      }
    }

    return count;
  }

  renderComparison = (timelineLabelType) => {
    const { classes, pageInfos, isDemo } = this.props;

    const diffCount = isDemo ? StatusDailyComparisonPanel.DEMO_DATA[timelineLabelType.value] : pageInfos[timelineLabelType.value].total - this.getDayBeforeCount(timelineLabelType.value);

    return (
      <div className={classes.box}>
        <div className={classes.circle} style={{ background: (timelineLabelType.value === TimelineLabelType.CLOSE.value) ? StatusDailyComparisonPanel.CLOSE_COLOR : timelineLabelType.color }}></div>
        <div>{(timelineLabelType.value === TimelineLabelType.APPROACH.value) ? DashboardTimelineType.APPROACH.text : timelineLabelType.text}</div>
        <div className={classes.count}>
          {(diffCount > 0 ? "+" : "") + diffCount}
        </div>
      </div>
    );
  }

  render() {
    const { classes, isDemo } = this.props;

    const hasKLFollowCallBeenEnabledUser = hasKLFollowCallBeenEnabled(this.props.user);

    return (
      <div className={classes.root}>
        <PanelHeader
          title={"ステータス別の前日比"}
          isDemo={isDemo}
          type={null}
          dateRanges={null}
          dateSelected={null}
          handleSelectDate={null}
          togglePlanDialog={null}
        />
        {(() => {
          // ローディング中
          if (!isDemo && this.props.isLoading) {
            return (
              <div className={classes.loaderContainer}>
                <Loader />
              </div>
            );
          }
          // ローディング完了 || デモ
          return (
            <div className={classes.comparisonContainer}>
              {this.renderComparison(TimelineLabelType.APPROACH)}
              {(hasKLFollowCallBeenEnabledUser || isDemo) && (
                <React.Fragment>
                  {this.renderComparison(TimelineLabelType.NON_CONNECT)}
                  {this.renderComparison(TimelineLabelType.DECLINED)}
                  {this.renderComparison(TimelineLabelType.CONNECT)}
                  {this.renderComparison(TimelineLabelType.SENT_DOCUMENT)}
                </React.Fragment>
              )}
              {this.renderComparison(TimelineLabelType.APPOINTMENT)}
              {this.renderComparison(TimelineLabelType.APPROACH_NG)}
              {this.renderComparison(TimelineLabelType.CLOSE)}
            </div>
          );
        })()}
      </div>
    );
  }
}

StatusDailyComparisonPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  isDemo: PropTypes.bool.isRequired,
  ownerType: PropTypes.string.isRequired,
  getDayBeforeCountByStatus: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  pageInfos: PropTypes.object.isRequired,
};

StatusDailyComparisonPanel.CLOSE_COLOR = '#999999'; // ダッシュボードではクローズだけこの色を表示する（見づらいため）

StatusDailyComparisonPanel.DEMO_DATA = {
  [TimelineLabelType.APPROACH.value]: 15,
  [TimelineLabelType.NON_CONNECT.value]: -4,
  [TimelineLabelType.DECLINED.value]: 0,
  [TimelineLabelType.CONNECT.value]: 3,
  [TimelineLabelType.SENT_DOCUMENT.value]: 0,
  [TimelineLabelType.APPOINTMENT.value]: 1,
  [TimelineLabelType.APPROACH_NG.value]: 0,
  [TimelineLabelType.CLOSE.value]: 1,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
    isDemo: state.accountSetting.showDemoData,
    isLoading: (typeof state.currentPersonStatus.isLoadingDayBeforeCountByStatuses === "object" && Object.keys(state.currentPersonStatus.isLoadingDayBeforeCountByStatuses).length > 0) ? Object.values(state.currentPersonStatus.isLoadingDayBeforeCountByStatuses).some(item => item === true) : true,
    pageInfos: state.currentPersonStatus.pageInfoDayBeforeCountByStatuses,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDayBeforeCountByStatus(data) {
      dispatch(getDayBeforeCountByStatus(data));
    },
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(StatusDailyComparisonPanel));



// WEBPACK FOOTER //
// ./src/components/OrderDashboard/panels/StatusDailyComparisonPanel.jsx